/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CombineLeads200ResponseData } from './CombineLeads200ResponseData';
import {
    CombineLeads200ResponseDataFromJSON,
    CombineLeads200ResponseDataFromJSONTyped,
    CombineLeads200ResponseDataToJSON,
} from './CombineLeads200ResponseData';

/**
 * 
 * @export
 * @interface CombineLeads200Response
 */
export interface CombineLeads200Response {
    /**
     * 
     * @type {CombineLeads200ResponseData}
     * @memberof CombineLeads200Response
     */
    data?: CombineLeads200ResponseData;
}

/**
 * Check if a given object implements the CombineLeads200Response interface.
 */
export function instanceOfCombineLeads200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CombineLeads200ResponseFromJSON(json: any): CombineLeads200Response {
    return CombineLeads200ResponseFromJSONTyped(json, false);
}

export function CombineLeads200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombineLeads200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CombineLeads200ResponseDataFromJSON(json['data']),
    };
}

export function CombineLeads200ResponseToJSON(value?: CombineLeads200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CombineLeads200ResponseDataToJSON(value.data),
    };
}

